export default "__VITE_ASSET__BWZW5C3c__"